import { render, staticRenderFns } from "./oe-preview-slice.vue?vue&type=template&id=3f8bd32a&scoped=true"
import script from "./oe-preview-slice.vue?vue&type=script&lang=ts"
export * from "./oe-preview-slice.vue?vue&type=script&lang=ts"
import style0 from "./oe-preview-slice.vue?vue&type=style&index=0&id=3f8bd32a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8bd32a",
  null
  
)

export default component.exports